import React, { Component, Fragment } from "react";

export default class Radio extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                    <form>
                        <div className="form-group">
                            <label>Mês: </label>
                            <select name="select" onChange={this.props.selectMes} className="form-control" value={this.props.mes}>
                                <option hidden>Selecione um mês</option>
                                <option value="Anual">Anual</option>
                                <option value="JAN">Janeiro</option>
                                <option value="FEV">Fevereiro</option>
                                <option value="MAR">Março</option>
                                <option value="ABR">Abril</option>
                                <option value="MAI">Maio</option>
                                <option value="JUN">Junho</option>
                                <option value="JUL">Julho</option>
                                <option value="AGO">Agosto</option>
                                <option value="SET">Setembro</option>
                                <option value="OUT">Outubro</option>
                                <option value="NOV">Novembro</option>
                                <option value="DEZ">Dezembro</option>
                            </select>
                        </div>
                    </form>
            </Fragment>
        )
    }
}